let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("foCcD")).then(() => parcelRequire('5HW4j'));